import React from 'react'
import globalStyle from '../styles/globalstyle'

const Banner = ({ type, image }) => {
  return (
    <div>
      {type === 'trapeze' || type === 'rectangle' ? (
        <div className="relative w-full h-[250px] md:h-[300px] lg:h-[400px] overflow-hidden">
          <img
            className={`w-full h-full object-cover ${
              type === 'trapeze' ? 'clip-custom' : 'border-b-4 border-card_borderColor shadow-2xl'
            }`}
            src={image}
            alt="Banner Image"
          />
        </div>
      ) : null}
    </div>
  )
}

export default Banner
